import { useClipboard as useChakraClipboard, useToast } from '@chakra-ui/react';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import Toast from '../components/Toast/Toast';

export type UseClipboardResponse = {
  onCopy: () => void;
  setValue: (val: string) => void;
};

export const useClipboard = (
  value = window.location.href,
  id = 'copy-link',
): UseClipboardResponse => {
  const { t } = useTranslation();
  const toast = useToast();
  const { onCopy, setValue } = useChakraClipboard(value);

  const copy = useCallback(() => {
    if (!toast.isActive(id)) {
      toast({
        id,
        render: () => <Toast fontWeight="bold">{t('global.linkCopied')}</Toast>,
        containerStyle: {
          minWidth: 0,
        },
      });
    }
    onCopy();
  }, [id, onCopy, t, toast]);

  return { onCopy: copy, setValue };
};
